import { useEffect, useState } from 'react'
import { superSearchApi } from '../api/superSearchApi'

// export const useSuperAppSearch = (path, query) => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!query) return;

//     const fetchData = async () => {
//       setLoading(true);
//       setError(null);

//       try {
//         const result = await superSearchApi(path, query);
//         setData(result);
//       } catch (err) {
//         setError(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [path, query]);

//   return { data, loading, error };
// };

export const useSuperAppSearch = (path, query, requestId) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!query) {
      setData(null)
      return
    }

    const fetchData = async () => {
      setLoading(true)
      setError(null)

      try {
        const result = await superSearchApi(path, query)
        setData(result)
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [path, query, requestId])

  return { data, loading, error }
}

export const useSearchPosts = (query) =>
  useSuperAppSearch('v1/superapp/search/?posts&', query)

export const useSearchCreators = (query) =>
  useSuperAppSearch('v1/superapp/search/?creators&', query)

export const useSearchHashtags = (query) =>
  useSuperAppSearch('v1/superapp/search/?hashtags&', query)

export const useSearchPlaylists = (query) =>
  useSuperAppSearch('v1/superapp/search/?playlists=null&', query)

export const useSearchAll = (query) =>
  useSuperAppSearch('v1/superapp/search/?', query)
